module.exports = __webpack_public_path__ + "static/media/record-voice-over.281b3e3d.svg";